import React from 'react';
import {Check, Close, Info} from '@material-ui/icons';
import {makeStyles, Typography, IconButton, Button} from '@material-ui/core';
import {colors} from '../../assets/styles/colors';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: '.5rem',
    padding: '.75rem',
    borderRadius: '.75rem',
    boxShadow: '0 4px 20px rgba(0, 0, 0, .12)',
    background: 'white',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingLeft: '.45rem',
  },
  headerLabel: {
    display: 'flex',
    alignItems: 'center',
    gap: '.75rem',
  },
  icon: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '.125rem',
    borderRadius: '50%',

    background: colors.primary,
    boxShadow: `0 0 0 .45rem ${colors.primary}33`,
    color: 'white',

    '&[data-color="success"]': {
      background: colors.success,
      boxShadow: `0 0 0 .45rem ${colors.success}33`,
      color: 'white',
    },

    '&[data-color="danger"]': {
      background: colors.danger,
      boxShadow: `0 0 0 .45rem ${colors.danger}33`,
      color: 'white',
    },

    '&[data-color="warning"]': {
      background: colors.warning,
      boxShadow: `0 0 0 .45rem ${colors.warning}33`,
      color: 'white',
    },

    '&[data-color="info"]': {
      background: colors.info,
      boxShadow: `0 0 0 .45rem ${colors.info}33`,
      color: 'white',
    },

    '&[data-color="secondary"]': {
      background: colors.secondary,
      boxShadow: `0 0 0 .45rem ${colors.secondary}33`,
      color: 'white',
    },
  },

  title: {
    fontSize: '1rem',
    fontWeight: 600,
    color: colors.grey900,
  },

  closeButton: {
    padding: 8,
    color: colors.grey500,
  },
  message: {
    fontSize: '.875rem',
    color: colors.grey600,
  },
  actionButton: {
    alignSelf: 'flex-start',
    textTransform: 'none',
    fontWeight: 600,
    fontSize: '.8rem',
    padding: '.25rem .75rem',
    marginTop: '.25rem',
  },
}));

type ToastAction = {
  label: string,
  onClick: () => void,
};

export type Props = {
  type: string,
  title: string,
  message: string,
  onClose?: () => void,
  action?: ToastAction,
};

const iconMap = {
  success: <Check fontSize="small" />,
  danger: <Close fontSize="small" />,
  warning: <Close fontSize="small" />,
  info: <Info fontSize="small" />,
  secondary: <Check fontSize="small" />,
};

export default function TiendadaToast(props: Props) {
  const {type, title, message, onClose, action} = props;
  const classes = useStyles();

  const handleActionClick = () => {
    if (action?.onClick) {
      action.onClick();
    }
    if (onClose) {
      onClose();
    }
  };

  return (
    <aside className={classes.root}>
      <header className={classes.header}>
        <div className={classes.headerLabel}>
          <span className={classes.icon} data-color={type}>
            {iconMap[type] || <Check fontSize="small" />}
          </span>
          <Typography variant="h4" className={classes.title}>
            {title}
          </Typography>
        </div>

        <IconButton
          className={classes.closeButton}
          size="small"
          onClick={onClose}
        >
          <Close fontSize="small" />
        </IconButton>
      </header>

      <Typography className={classes.message}>{message}</Typography>

      {action && (
        <Button
          className={classes.actionButton}
          color="primary"
          size="small"
          onClick={handleActionClick}
        >
          {action.label}
        </Button>
      )}
    </aside>
  );
}
